var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup23(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.67,
    height: 122.243,
    viewBox: "0 0 183.67 122.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(91.521 -1333.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1086.244,446.1a27.78,27.78,0,0,1-19.5,8.556l-42.2.672a58.39,58.39,0,0,1-58.964-52.646l100.922-1.6a26.785,26.785,0,0,1,26.872,22.524,24.818,24.818,0,0,1,.332,3.514,26.292,26.292,0,0,1-7.456,18.98",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1117.523,391.75a26.968,26.968,0,0,1-16.081,24.977,36.331,36.331,0,0,0-35.1-25.122l-101.114,1.6-.4-25.821,125.483-2a26.767,26.767,0,0,1,27.2,26.126Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1148.271,359.455a26.879,26.879,0,0,1-21.776,26.73,36.233,36.233,0,0,0-36.339-30.271l-125.484,2-.065-4.3A18.033,18.033,0,0,1,982.342,335.3l138.715-2.207a26.795,26.795,0,0,1,27.214,26.359",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup23);
export default __webpack_public_path__ + "static/media/Group 23.bcaf7706c78ba08491ffc95f71b4cc05.svg";
export { ForwardRef as ReactComponent };